module.exports = __webpack_public_path__ + "img/capsule-main-image.43e3e69c.png";